import { useContext, useEffect, useState } from "react";
import CancelButton from "../../assets/images/CancelButton.svg";
import { HelpHubTasksTypes, QuestCriteriaWithStatusType } from "./CustomHelpHub.type";
import QuestContext from "../QuestWrapper";
import config from "../../config";
import { claimQuest } from "./CustomHelphub.service";
import UpdatesImage from "../../assets/images/UpdatesImage.png";
import TaskUpButton from "../../assets/images/TaskUpButton.svg";
import TaskCompleted from "../../assets/images/TaskCompleted.svg";
import { getColorVariations } from "./components/helperfunction";
import { extractGradientColors, useGeneral } from "../../general";
const CustomHelpHubTasks = (props: HelpHubTasksTypes) => {
  const {
    tasksData,
    questId,
    userId,
    token,
    contentConfig,
    styleConfig,
    claimStatusTasks = [],
    setClaimStatusTasks,
    onlineComponent,
    setHelpHub,
    uniqueUserId,
    uniqueEmailId,
    campaignVariationId,
    entityAuthenticationToken,
    isActive,
    BrandTheme,
    QuestThemeData,
    contentData,
    isOffline,
    onClose,
  } = props;

  const { apiKey, entityId, apiType, themeConfig, user } = useContext(
    QuestContext.Context
  );

  let BACKEND_URL =
    apiType == "STAGING" ? config.BACKEND_URL_STAGING : config.BACKEND_URL;
  const general = useGeneral('quest')

  useEffect(() => {
    if (isOffline) return;
    general.trackEvent(
      "quest-helphub-tasks-loaded",
      (uniqueUserId || userId || user.userId)!,
      {},
      true,
      !uniqueUserId,
      true
    );
  }, []);

  const readUpdate = async (criteriaId: string, links?: string) => {
    window.open(links, "_blank");
    if (onlineComponent) {
      let claimResponse = await claimQuest(
        BACKEND_URL,
        entityId,
        questId,
        userId,
        token,
        apiKey,
        criteriaId,
        campaignVariationId,
        [],
        uniqueUserId,
        uniqueEmailId,
        apiType,
        entityAuthenticationToken
      );
      if (claimResponse.success) {
        if (!claimStatusTasks.includes(criteriaId)) {
          setClaimStatusTasks &&
            setClaimStatusTasks([...claimStatusTasks, criteriaId]);
        }
      }
    } else {
      if (!claimStatusTasks.includes(criteriaId)) {
        setClaimStatusTasks &&
          setClaimStatusTasks([...claimStatusTasks, criteriaId]);
      }
    }
  };

  const [openTaskDiv, setOpenTaskDiv] = useState<number | undefined>(undefined);

  return (
    <div
      className={"helpHubTaskCont animatedDissolve"}
    >
      {/* for heading  */}
      <div
        className="q-custom-helphub-tasks-upper-cont"
      >
        <div className="task-head-text-div">
          <div
            className="q-custom-helphub-tasks-upper-cont-text-head"
          >
            Get Started
          </div>
          <div
            className="q-custom-helphub-tasks-upper-cont-text-para"
          >
            Follow these steps to get your community started.
          </div>
        </div>
        <div className="q-custom-helphub-tasks-upper-cont-text-button">
          <img src={CancelButton} alt="" onClick={() => { setHelpHub(false); isActive && isActive(false); onClose && onClose(false) }} />
        </div>
      </div>

      <div className="custom-helphub-task-container">
        <div className="q-custom-helphub-tasks-progress-cont">
          <div
            className="q-custom-helphub-tasks-progress-per"
          >
            STEP {claimStatusTasks?.length}/{tasksData?.length}
          </div>

          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
              gap: "4.891px",
            }}
          >
            {onlineComponent &&
              tasksData?.map((value, index) => {
                return (
                  <div
                    className="q-custom-helphub-tasks-progress-bar-tabs "
                    style={{
                      width: `${Math.ceil(100 / tasksData.length)}%`,
                      background: `${value.completed ||
                        claimStatusTasks.includes(value?.criteriaId)
                        ? "#00CA8D" : openTaskDiv === index
                          ? "#00CA8D" : ""}`,
                      borderRadius: `${index == 0
                        ? "8px 0px 0px 8px"
                        : index === tasksData?.length - 1
                          ? "0px 8px 8px 0px"
                          : ""
                        }`,
                    }}
                  ></div>
                );
              })}

            {!onlineComponent &&
              tasksData?.map((value, index) => {
                return (
                  <div
                    className="q-helphub-tasks-progress-bar-tabs "
                    style={{
                      width: `${Math.ceil(100 / tasksData.length)}%`,
                      background: `${claimStatusTasks?.includes(value?.criteriaId)
                        ? BrandTheme?.primaryColor ||
                        QuestThemeData?.accentColor ||
                        BrandTheme?.secondaryButton ||
                        "var(--Primary, linear-gradient(84deg, #9035FF 0.36%, #0065FF 100.36%))"
                        : openTaskDiv === index
                          ? BrandTheme?.primaryColor ||
                          QuestThemeData?.accentColor ||
                          BrandTheme?.secondaryButton ||
                          "var(--Primary-Grape-400, #A357FF)"
                          : ""
                        }`,
                      borderRadius: `${index == 0
                        ? "8px 0px 0px 8px"
                        : index === tasksData?.length - 1
                          ? "0px 8px 8px 0px"
                          : ""
                        }`,
                    }}
                  ></div>
                );
              })}
          </div>
        </div>
        <div className="q-helphub-tasks-task-cont">
          {tasksData?.map((ele: QuestCriteriaWithStatusType, index: number) => (
            <div
              className={"q-custom-helphub-tasks-single-task"}
              onClick={() => {
                if (openTaskDiv === index) {
                  setOpenTaskDiv(undefined);
                } else {
                  setOpenTaskDiv(index);
                }
              }}
              key={index}
            >
              <div className="single-task-close-detail">
                <div className="q-custom-helphub-tasks-single-task-detail">
                  <div
                    className="q-custom-helphub-tasks-single-task-step"
                  >
                    STEP {index + 1}
                  </div>
                  <div
                    className="q-custom-helphub-tasks-single-task-head"
                  >
                    {ele?.linkTitle}
                  </div>
                  <div
                    className="q-custom-helphub-tasks-single-task-para"
                  >
                    {ele?.description}
                  </div>
                </div>
                {/* <img
                  style={{
                    padding: claimStatusTasks?.includes(ele?.criteriaId)
                      ? "5px 4px"
                      : "",
                    rotate: claimStatusTasks?.includes(ele?.criteriaId)
                      ? ""
                      : index === openTaskDiv
                        ? ""
                        : "180deg",
                  }}
                  src={
                    ele.completed || claimStatusTasks?.includes(ele?.criteriaId)
                      ? TaskCompleted
                      : index === openTaskDiv
                        ? TaskUpButton
                        : TaskUpButton
                  }
                  alt=""
                /> */}
                {ele.completed || claimStatusTasks?.includes(ele?.criteriaId) ? (
                  <img src={TaskCompleted} alt="" />
                ) : (
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none" >
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M2.95437 10.4934C2.77465 10.2837 2.79893 9.96804 3.0086 9.78833L7.67526 5.78833C7.86251 5.62784 8.13881 5.62784 8.32606 5.78833L12.9927 9.78833C13.2024 9.96804 13.2267 10.2837 13.047 10.4934C12.8672 10.703 12.5516 10.7273 12.3419 10.5476L8.00066 6.8265L3.65939 10.5476C3.44973 10.7273 3.13408 10.703 2.95437 10.4934Z" fill="#6B7280" stroke="#6B7280" stroke-width="0.6" stroke-linecap="round" />
                  </svg>
                )}
              </div>

              <div
                className={`${index === openTaskDiv
                  ? "custom-single-task-open-div-cont"
                  : "custom-single-task-close-div-cont"
                  }`}
              >
                <div >
                  <div
                    className="custom-single-task-close-div-text"
                    style={{
                      width: !!ele?.imageUrl ? "calc(100% - 120px)" : "100%",
                    }}
                  >
                    <p>
                      Explore your community's current missions and pick one to start.
                    </p>
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        readUpdate(ele?.criteriaId, ele?.linkUrl);
                      }}
                    >
                      Start Now
                    </button>
                  </div>
                  {ele?.imageUrl && (
                    <div className="custom-single-task-close-div-image-cont">
                      <img src={ele?.imageUrl || UpdatesImage} alt="" />
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
        <div
          className="q-helphub-tasks-lower-cont"
        ></div>
      </div>
    </div>
  );
};

export default CustomHelpHubTasks;
